function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(357.86 -256.28)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m-356.11 257.07 0.47617 1.1906h1.905l0.47625-1.1906-0.95248 0.47624-0.47628-0.47624-0.47617 0.47624zm0.47617 1.6669c-0.9525 0.47619-1.1905 2.143-1.1905 2.143s-0.23818 0.95252 1.1905 0.95252h1.905c1.4287-1e-5 1.1906-0.95252 1.1906-0.95252s-0.23814-1.6668-1.1906-2.143zm0.24053 0.40225h1.418c0.70917 0.35457 0.88644 1.5952 0.88644 1.5952s0.17732 0.70925-0.88644 0.70925h-1.418c-1.0638 0-0.88651-0.70925-0.88651-0.70925s0.17734-1.2407 0.88651-1.5952z",
  strokeWidth: 0.23812
}));

var SvgSackOutline = function SvgSackOutline(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 6.3499 6.3499",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSackOutline, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sack-outline.6d6f7161.svg";
export { ForwardRef as ReactComponent };